<template>
  <div>
    <filters
      v-model="filterData"
      :catalogs="catalogs"
      :defaults="filterDefaults"
      :loading="loading"
      @submitFitlers="fetchRecords(filterData)"
      @downloadReport="downloadReport"
    />
    <catalog-table
      ref="recordsTable"
      :table-data="fetchedRecords"
      :pagination-info="null"
      :tableHeaders="tableHeaders"
      :propsToSearch="recordsSearchableProps"
      :loading="loading"
      :loading-content-props="LOADING_PROPS"
      :page-size="filterData.pageSize"
      dummy-search
      @updatedSearchQuery="filterData.searchQuery = $event"
    >
      <div
        v-if="filterData.movementType !== 'out'"
        slot="supplyMovement-cell"
        slot-scope="{ value }"
        class="text-left"
      >{{ value }}</div>
      <div
        v-if="filterData.movementType !== 'in'"
        slot="sinister-cell"
        slot-scope="{ value }"
        class="text-left"
      >{{ value }}</div>
      <div
        v-if="filterData.movementType !== 'in'"
        slot="isInvoice-cell"
        slot-scope="{ item, value }"
        class="text-left"
      >
        <div v-if="item.isOutput">{{ value }}</div>
      </div>
      <div
        slot="movementQuantityColumn-cell"
        slot-scope="{ item }"
        class="text-left"
      >{{ item.quantityEntryOutput.toFixed(6) }}</div>
      <div slot="unitCost-cell" slot-scope="{ value }" class="text-left">{{ value | money }}</div>
    </catalog-table>
  </div>
</template>
<script>
import Filters from "./Filters";
import { CatalogTable } from "@/components/";

import warehouseService from "@/services/purchase/warehouse";
// import { cloneDeep } from "lodash";

import { cloneDeep, debounce } from "lodash";
import moment from "moment";
import {
  DEFAULT_SEARCH_PARAMS,
  DEFAULT_CATALOGS,
  CONSTANT_HEADERS,
  INPUT_HEADERS,
  OUTPUT_HEADERS,
  LAST_CONSTANT_HEADERS,
  LOADING_PROPS,
} from "./utils";

export default {
  name: "IOReportIndex",
  props: {
    filterDefaults: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CatalogTable,
    Filters,
  },
  data() {
    return {
      firstFetchFlag: false,
      filterData: {
        ...DEFAULT_SEARCH_PARAMS(),
        ...this.filterDefaults,
      },
      catalogs: DEFAULT_CATALOGS(),
      recordsSearchableProps: ["name"],
      fetchedRecords: [],
      loading: null,
      LOADING_PROPS,
      CONSTANT_HEADERS,
      INPUT_HEADERS,
      OUTPUT_HEADERS,
      LAST_CONSTANT_HEADERS,
    };
  },
  computed: {
    tableHeaders() {
      const { movementType, iwarehouses = [] } = this.filterData;
      const {
        CONSTANT_HEADERS,
        INPUT_HEADERS,
        OUTPUT_HEADERS,
        LAST_CONSTANT_HEADERS,
      } = this;

      let initialHeaders = cloneDeep(CONSTANT_HEADERS);
      switch (movementType) {
        case "in":
          return {
            ...initialHeaders,
            ...INPUT_HEADERS,
            ...LAST_CONSTANT_HEADERS,
          };
        case "out":
          return {
            ...initialHeaders,
            ...OUTPUT_HEADERS,
            ...LAST_CONSTANT_HEADERS,
          };

        default:
          return {
            ...initialHeaders,
            ...INPUT_HEADERS,
            ...OUTPUT_HEADERS,
            ...LAST_CONSTANT_HEADERS,
          };
      }
    },
  },
  methods: {
    downloadReport() {
      const headers = {
        ...CONSTANT_HEADERS,
        ...INPUT_HEADERS,
        ...OUTPUT_HEADERS,
        ...LAST_CONSTANT_HEADERS,
      };

      const payload = {
        ...this.filterData,
        headers: Object.values(headers),
        xls: true,
      };
      this.fetchRecords(payload);
    },
    fetchRecords(payload) {
      if (payload) {
        this.loading = true;
        warehouseService
          .fetchEntries(payload)
          .then((resp) => {
            if (!payload.xls) {
              this.fetchedRecords = resp.sort((a, b) => {
                const dateA = moment(a.dateOfMovementRaw);
                const dateB = moment(b.dateOfMovementRaw);
                return dateA.diff(dateB) >= 0 ? -1 : 1;
              });
              const warehouseId = this.filterData.warehouse;
              if (warehouseId) {
                const warehouse = this.catalogs.warehouses.find(
                  ({ id }) => id == warehouseId
                );
                const almacen = warehouse.name
                  .toLowerCase()
                  .replaceAll(" ", "_");
                this.$router.replace(
                  {
                    query: {
                      almacen,
                    },
                  },
                  () => {}
                );
              }
            }
          })
          .catch(this.$fireErrorResponse)
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  watch: {
    "filterData.movementType": {
      handler() {
        this.filterData.movementReason = null;
      },
    },
    "filterData.searchQuery": debounce(function (newVal) {
      if ((!!newVal && newVal.length > 2) || newVal !== undefined) {
        this.filterData.currentPage = 1;
        this.fetchRecords(this.filterData);
      }
    }, 500),
  },
  created() {
    this.loading = true;
    let { almacen: warehouse } = this.$route.query;
    return warehouseService
      .fetchiWarehouse()
      .then((warehouses) => {
        this.catalogs.iwarehouses = warehouses;
        if (warehouse) {
          const warehouseSlug = warehouse.replaceAll("_", "-");
          const warehouseId = warehouses.find(({ slug }) =>
            slug.includes(warehouseSlug.substring(0, 4))
          );
          this.filterData.iwarehouses = [warehouseId.id];
        }
        // else {
        //   this.filterData.iwarehouses = warehouses;
        // }
      })
      .catch(this.$fireErrorResponse)
      .finally((this.loading = false));
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Reports/InputsOutputsReport/Index.vue